import scrollAnimator from 'viralstyle-ui/src/scrollAnimator';
import storage from 'viralstyle-ui/src/storage';
import sumBy from 'lodash/sumBy';
import get from 'lodash/get';
import each from 'lodash/each';
import clone from 'lodash/clone';
import cloneDeep from 'lodash/cloneDeep';
import size from 'lodash/size';
import head from 'lodash/head';
import isObject from 'lodash/isObject';
import find from 'lodash/find';
import Vue from 'vue';
import { mapState } from 'vuex';

import config from 'config';

export default {
  data: () => ({
    visitRecords: storage.get('visit-records', { storages: ['session'] }),
  }),
  computed: {
    ...mapState({
      cart: state => state.cart.cart,
    }),
    cartHasApparel() {
      return find(get(this.cart, 'items'), product => product.group === 'Apparel');
    },
    cartHasNonApparel() {
      return find(get(this.cart, 'items'), product => product.group !== 'Apparel');
    },
    holidayMessageObject() {
      if (this.cartHasApparel && this.cartHasNonApparel) {
        return config.HOLIDAY_MESSAGE.bothInCart;
      } else if (this.cartHasApparel) {
        return config.HOLIDAY_MESSAGE.apparel;
      } else if (this.cartHasNonApparel) {
        return config.HOLIDAY_MESSAGE.nonApparel;
      } else {
        return {};
      }
    },
    showHolidayMessage() {
      let now = new Date();

      return this.holidayMessageObject.message && now.getDate() < config.HOLIDAY_MESSAGE.endDay && now.getMonth() === 11;
    },
  },
  methods: {
    async $_scrollToFirstError() {
      let firstError;

      // wait for the DOM to update errors before trying to select them
      await Vue.nextTick();

      each(document.getElementsByClassName('text-error'), element => {
        if (element.style.display !== 'none') {
          firstError = element.parentNode;
          return false;
        }
      });

      if (firstError) {
        scrollAnimator.scrollTo(firstError, 500, 120);
      }
    },
    $_selectProductByFn(campaign, selectedProduct, selectedColor, fn, hashHelper) {
      let cache = {
        product: cloneDeep(selectedProduct),
        color: cloneDeep(selectedColor),
      };

      selectedProduct = {};
      selectedColor = {};

      for (let product of campaign.products) {
        for (let color of product.colors) {
          if (fn(color, product)) {
            selectedProduct = product;
            selectedColor = color;

            if (hashHelper) {
              hashHelper.update('pid', product.id);
              hashHelper.update('cid', color.color_id);
            }

            break;
          }
        }

        if (size(selectedProduct)) break;
      }

      // if we failed to find a product or color and have cached values
      if (size(cache.product) && size(cache.color) && (!size(selectedProduct) || !size(selectedColor))) {
        selectedProduct = cache.product;
        selectedColor = cache.color;
      }

      // if there was no cached product and still no product or color set, set them to the first available.
      if (campaign.products.length && campaign.products[0].colors.length && (!size(selectedProduct) || !size(selectedColor))) {
        selectedProduct = head(campaign.products);
        selectedColor = head(selectedProduct.colors);
      }

      return { selectedProduct, selectedColor };
    },
    $_removeTags(string) {
      return string ? string.replace(/<[^>]+>/gm, ' ').replace(/\s{2,}/g, ' ').replace('&nbsp;', ' ').trim() : '';
    },
    $_visitRecorded(publicName, slug) {
      let visitRecorded = false;

      if (!this.visitRecords) {
        this.visitRecords = {};
      }

      if (!this.visitRecords[publicName]) {
        this.visitRecords[publicName] = [];
      }

      each(this.visitRecords[publicName], record => {
        if (
          (isObject(record) && record.sl === slug) ||
          (record === slug)
        ) {
          visitRecorded = true;
          return false;
        }
      });

      return visitRecorded;
    },
    $_clearCoupon() {
      let query = clone(this.$route.query);

      delete query.coupon;

      this.$router.replace({ name: this.$route.name, params: this.$route.params, hash: this.$route.hash, query }).catch(err => {});
    },
    async applyUrlCoupon() {
      if (this.$route.query.coupon) {
        this.$store.commit('updateState', { object: this.$store.state.cart, property: 'coupon', value: this.$route.query.coupon });

        try {
          await this.$store.dispatch('applyCoupon');

          this.$_clearCoupon();
        } catch (e) {
          if (e && e.status !== 400) {
            this.$_clearCoupon();
          }
        }
      }
    },
    priceWithUpcharges(price, upcharges, size) {
      if (size && upcharges && upcharges[size]) {
        return (price + parseFloat(upcharges[size]));
      } else {
        return price;
      }
    },
    hasUsOnlyProductInCart() {
      if (this.cart) {
        let hasUsOnlyProductInCart = false;

        each(this.cart.items, item => {
          if (item.us_only) {
            hasUsOnlyProductInCart = true;
            return false;
          }
        });

        return hasUsOnlyProductInCart;
      }
    },
    isDisallowedPaypalDomain() {
      // TODO: Temporary Block list array, to be replaced by WL domain setting returned from API
      let disallowedDomains = ['teezoz.com','hanabiv.com','leomessibarca.com','lezdta.com','teesleek.com'];
      let allowedDomains = ['viralstyle.com','vrlstyl.com','viralstyle.cc'];
      
      // Temp remove from ALL whitelabels
      // return disallowedDomains.includes(window.location.host);
      return !allowedDomains.includes(window.location.host);
    },
  },
};